import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../../my-app/src/environments/environment';

const AGENT_API_URL = environment.agentApiUrl;

@Injectable({
  providedIn: 'root'
})
export class ChatApiService {
  private _sessionId: string | null = null;

  constructor(
    private http: HttpClient,
    private keycloakService: KeycloakService
  ) { }

  get sessionId(): string | null {
    return this._sessionId;
  }

  /**
   * Sends a message to the agent API and processes the response.
   * @param formData The message and files from the user.
   */
  async sendMessage(formData: FormData): Promise<Observable<any>> {
    const isLoggedIn = await this.keycloakService.isLoggedIn();
    let userId = 'anonymous';
    let token = '';

    if (isLoggedIn) {
      const keycloakInstance = this.keycloakService.getKeycloakInstance();
      if (keycloakInstance.token) {
        token = keycloakInstance.token;
      }
      userId = keycloakInstance.tokenParsed?.['sub'] || 'anonymous';
    }

    return new Observable<any>(observer => {
      const controller = new AbortController();
      const signal = controller.signal;

      const headers: HeadersInit = { };

      if (isLoggedIn && token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      fetch(`${AGENT_API_URL}/run_unified`, {
        method: 'POST',
        headers: headers,
        body: formData,
        signal: signal
      }).then(response => response.json())
        .then(data => {
          if (data) {
            observer.next(data);
          }
          observer.complete();
        }).catch(err => {
          observer.error(err);
        });

      return () => {
        controller.abort();
      };
    });
  }

  async getJobStatus(jobId: string): Promise<any> {
    const isLoggedIn = await this.keycloakService.isLoggedIn();
    let token = '';

    if (isLoggedIn) {
      const keycloakInstance = this.keycloakService.getKeycloakInstance();
      if (keycloakInstance.token) {
        token = keycloakInstance.token;
      }
    }

    const headers: HeadersInit = { };

    if (isLoggedIn && token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return fetch(`http://127.0.0.1:8001/status/${jobId}`, {
      method: 'GET',
      headers: headers,
    }).then(response => response.json());
  }

  async createSession() {
    const isLoggedIn = await this.keycloakService.isLoggedIn();
    let userId = 'anonymous';
    const appName = "pvm_agent"; // Hardcoded appName

    if (isLoggedIn) {
      userId = this.keycloakService.getKeycloakInstance().tokenParsed?.['sub'] || 'anonymous';
    }

    const sessionApiUrl = `${AGENT_API_URL}/apps/${appName}/users/user/sessions`;

    return this.http.post<any>(sessionApiUrl, {}).pipe(
      tap(response => {
        console.log('Session creation response:', response);
        if (response && response.id) {
          this._sessionId = response.id;
          // console.log('Session ID:', this._sessionId)
        }
      })
    );
  }
}